import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import ConsultantReferralsReceived from '../ConsultantReferralForm/ConsultantReferralsReceived';

class RecommendationsReceivedModal extends Component {
  constructor(props) {
    super(props);
    this.state = { showModal: true };

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  handleCloseModal() {
    this.setState({ showModal: false });
  }

  render() {
    const { showModal } = this.state;

    return (
      <Modal show={showModal} onHide={this.handleCloseModal}>
        <Modal.Header closeButton />
        <Modal.Body>
          <ConsultantReferralsReceived {...this.props} />
        </Modal.Body>
      </Modal>
    );
  }
}

export default RecommendationsReceivedModal;
